module.exports = __webpack_public_path__ + "img/weddingRingsSoleil-emotion-02@2x.cf82193.webp";